export default __webpack_public_path__ + "media/color/waves-9ccd7125.svg";